import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

import vuetify from '@/plugins/vuetify'
import qs from 'qs'

Vue.config.productionTip = false

Vue.prototype.dateFormat = function (date, format = 'YY-MM-DD hh:mm:ss') {
  var year = date.getFullYear(),
    month = date.getMonth() + 1, //月份是从0开始的
    day = date.getDate(),
    hour = date.getHours(),
    min = date.getMinutes(),
    sec = date.getSeconds()
  var preArr = Array.apply(null, Array(10)).map(function (elem, index) {
    return '0' + index
  })
  var newTime = format
    .replace(/YY/g, year)
    .replace(/MM/g, preArr[month] || month)
    .replace(/DD/g, preArr[day] || day)
    .replace(/hh/g, preArr[hour] || hour)
    .replace(/mm/g, preArr[min] || min)
    .replace(/ss/g, preArr[sec] || sec)
  return newTime
}

Vue.prototype.hexpad = function (num) {
  return (num < 16 ? '0' : '') + num.toString(16).toUpperCase()
}



Vue.prototype.$qs = qs


new Vue({
  el: '#app',
  router,
  store,
  vuetify,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js